export var Goal = /*#__PURE__*/function (Goal) {
  Goal[Goal["PREVENT"] = 1] = "PREVENT";
  Goal[Goal["PLAN"] = 2] = "PLAN";
  Goal[Goal["PREGNANT"] = 3] = "PREGNANT";
  Goal[Goal["RECOVERY"] = 4] = "RECOVERY";
  Goal[Goal["POSTPARTUM"] = 5] = "POSTPARTUM";
  Goal[Goal["PERIMENOPAUSE"] = 6] = "PERIMENOPAUSE";
  return Goal;
}(Goal || {});